



















import Vue from "vue";

import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required } from "@/shared/validationRules";
import {
  ProductListUnit,
  produktResource,
} from "@megarax/client/src/resources/plm";
import { userResource } from "@megarax/client/src/resources/iam";

const validationRules = {
  name: required,
};

export default createComponent({
  components: {},
  props: {
    value: {
      type: ProductListUnit,
      required: true,
    },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      validationRules,
      produktResource,
      userResource,
    };
  },
});
